/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProviderTypes = {
    Salesforce: 'SALESFORCE',
    Hubspot: 'HUBSPOT'
} as const;
export type ProviderTypes = typeof ProviderTypes[keyof typeof ProviderTypes];


export function ProviderTypesFromJSON(json: any): ProviderTypes {
    return ProviderTypesFromJSONTyped(json, false);
}

export function ProviderTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderTypes {
    return json as ProviderTypes;
}

export function ProviderTypesToJSON(value?: ProviderTypes | null): any {
    return value as any;
}

